import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AnexoIcone from '../../../../../../components/Anexos/AnexoIcone';
import urlHelper from '../../../../../../helpers/UrlHelper';

import './style.scss';

export default function FileDownload({ conteudo, url }) {
  var nome = url || conteudo;
  var index = nome && nome.indexOf('.');
  var extensao = nome && index && nome.substring(index + 1);

  return (
    <>
      {
        <>
          <a className="linkFile" href="#" onClick={() => {urlHelper.download(url)}} target="_blank" rel="noreferrer">
            <Row >
              <Col sm={2}>
                <AnexoIcone anexo={extensao} style={{ fontSize: "3em" }} />
              </Col>
              <Col>
                  {nome}
              </Col>
            </Row>
          </a>
        </>
      }
    </>)
}
